import { useMemo } from 'react';

import useAppointmentStore, {
  isInBranchAppointment as isInBranchSelector,
  isOnlineAppointment as isOnlineSelector,
} from '@/store/AppointmentStore';
import useFeatureFlagsStore from '@/store/FeatureFlagsStore';

const useFallbackWorkTypeId = (): string => {
  const isInBranch = useAppointmentStore(isInBranchSelector);
  const isOnline = useAppointmentStore(isOnlineSelector);
  const destinations = useAppointmentStore((state) => state.destinations);
  const useNewDestinations = useFeatureFlagsStore(
    (state) => state.featureFlags.useNewDestinations,
  );

  return useMemo(() => {
    if (isOnline) {
      return (
        destinations.find((destination) => destination.name === 'Unknown')
          ?.workTypeId ?? ''
      );
    }

    if (isInBranch) {
      const inBranchApiName = useNewDestinations
        ? 'USA_Mainland'
        : 'United_States_&_Canada';
      return (
        destinations.find(
          (destination) => destination.destinationApiName === inBranchApiName,
        )?.workTypeId ?? ''
      );
    }

    return '';
  }, [isInBranch, isOnline, destinations, useNewDestinations]);
};

export default useFallbackWorkTypeId;
